<template>
    <div class="op-section-header">
        <div>
            <h2>{{ title }}</h2>
            <p v-if="description">{{ description }}</p>
        </div>
        <v-btn v-if="button" small outlined color="primary" @click="$emit('action')">
            <v-icon v-if="icon" left small>{{ icon }}</v-icon>{{ button }}
        </v-btn>
    </div>
</template>

<script>
export default {
    name: "OtherProceedingSectionHeader",
    props: {
        title: { type: String, required: true },
        description: { type: String, default: "" },
        button: { type: String, default: "" },
        icon: { type: String, default: "" },
    },
};
</script>
